import * as z from "zod";
import { gql } from "graphql-request";
import { ImageFragment } from "../image";
import { SysFragment } from "../sys";

import { NewsEntryExternalLink } from "./newsEntryExternalLink";

export const SmallNewsEntryExternalLink = NewsEntryExternalLink.extend({
  __typename: z.literal("SmallNewsEntryExternalLink"),
});

export type SmallNewsEntryExternalLink = z.infer<
  typeof SmallNewsEntryExternalLink
>;

export const SmallNewsEntryExternalLinkFragment = gql`
  fragment SmallNewsEntryExternalLinkFragment on SmallNewsEntryExternalLink {
    sys {
      ...SysFragment
    }
    title
    linkUrl
    linkThumbnail {
      ...ImageFragment
    }
    linkThumbnailEn: linkThumbnail(locale: "en") {
      ...ImageFragment
    }
  }

  ${SysFragment}
  ${ImageFragment}
`;
